module.exports = __webpack_public_path__ + "static/img/2_01.efc8b2d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/docs/03/2_01.jpg
// module id = bYlB
// module chunks = 1